<template>
  <v-text-field
    ref="input"
    v-model="titleText"
    v-tooltip="showTitleTooltip ? title : ''"
    density="compact"
    autocomplete="off"
    :disabled="disabled"
    flat
    solo
    background-color="#FFFFFF00 !important"
    @input="setShowTitleTooltip()"
  />
</template>

<script>
export default {
  name: 'TitleField',
  props: {
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTitleTooltip: false,
    };
  },
  computed: {
    titleText: {
      get() {
        return this.title;
      },
      set(value) {
        this.$emit('set-title', value);
        this.setShowTitleTooltip();
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setShowTitleTooltip();
    });
  },
  methods: {
    isTitleOverflow() {
      return this.$children[0].$refs.input.scrollWidth > this.$children[0].$refs.input.offsetWidth;
    },
    setShowTitleTooltip() {
      this.showTitleTooltip = this.isTitleOverflow();
      this.$emit('set-show-title-tooltip', this.showTitleTooltip);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  input {
    cursor: pointer;
    margin: 0 0 4px !important;
    padding: 0;
    color: var(--ds-color-text-1) !important;
    font-size: var(--ds-font-size-baseline);
    font-weight: var(--ds-font-weight-semibold);
    text-overflow: ellipsis;
    width: 100%;
  }

  .v-input {
    &__control {
      min-height: 26px !important;
      display: grid;
    }

    &__slot {
      margin: 0 !important;
      padding: 0 !important;
      min-height: 0 !important;
    }
  }

  .v-text-field {
    padding: 0 !important;
    margin: 0 !important;

    &__details {
      display: none;
    }
  }
}

</style>
